<div class="w-full bg-white">
  <!-- This part is already correct: Hide sub-header for Kalakar -->
  <div class="bg-white fixed top-0 inset-x-0 z-10">
    <ng-container *ngIf="isOwner">
      <app-sub-header></app-sub-header>
    </ng-container>

    <!-- STAFF (PURE STAFF ONLY) -->
    <ng-container *ngIf="isStaffUser">
      <app-rmportal-header></app-rmportal-header>
    </ng-container>

    <!-- GST STAFF -->
    <ng-container *ngIf="isGstStaff">
      <app-invoice-gst-header></app-invoice-gst-header>
    </ng-container>

    <!-- KARIGAR -->
    <ng-container *ngIf="isKalakar">
      <app-kalakaar-header></app-kalakaar-header>
    </ng-container>

    <!-- CUSTOMER -->
    <ng-container *ngIf="isCustomer">
      <app-customer-header></app-customer-header>
    </ng-container>

    <ng-container *ngIf="isCA">
      <app-ca-header></app-ca-header>
    </ng-container>
  </div>

  <!--
    MODIFICATION:
    Use [ngClass] to conditionally apply the top margin.
    The classes 'mt-10' and 'xl:mt-12' will only be added if the user is NOT a kalakar.
  -->
  <div
    [ngClass]="{
      'mt-12': !isKalakar && !isCustomer,
    }"
  >
    <router-outlet></router-outlet>
  </div>
</div>
